var _defs, _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaCursos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-200{fill:#444 !important;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M16.3,26.4h-.6a12.4,12.4,0,0,1-6-1.5c-1.4-.9-2.5-1.8-2.5-3.8v-5H8.7v5c0,1.2.5,1.7,1.8,2.5a9.8,9.8,0,0,0,5.3,1.3h.5a10.7,10.7,0,0,0,5.2-1.3c1.3-.8,1.8-1.3,1.8-2.5v-5h1.5v5c0,2-1.1,2.9-2.5,3.8A12.4,12.4,0,0,1,16.3,26.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M16,20.3h-.6L3.1,14.1a1.4,1.4,0,0,1-.7-1.2,1.5,1.5,0,0,1,.7-1.2l12.3-6a1.3,1.3,0,0,1,1.2,0l12.3,6a1.5,1.5,0,0,1,.7,1.2,1.4,1.4,0,0,1-.7,1.2L16.6,20.2ZM4.1,12.9,16,18.8l11.9-5.9L16,7.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M27.7,23.8h-.6a.9.9,0,0,1-.9-.9V19a1.3,1.3,0,0,1,.6-1.2l.6.9.5-.9a1.3,1.3,0,0,1,.6,1.2v3.9A.9.9,0,0,1,27.7,23.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 26.6,
    y: 13.9,
    width: 1.5,
    height: 5.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaCursos);
export default __webpack_public_path__ + "static/media/ga-cursos.4d22ba95.svg";
export { ForwardRef as ReactComponent };